import React from "react";
import HarvestCalendar from "@/components/HarvestCalendar";
import YieldChart from "@/components/YieldChart";

export default function Harvest() {
  return (
    <div className="space-y-10" data-testid="harvest-page">
      <div className="max-w-3xl">
        <div className="label-overline">Harvest</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter mt-2">
          The year, in color.
        </h1>
        <p className="text-foreground/70 mt-4 max-w-xl leading-relaxed">
          A 12-month map of your garden's harvest windows, plus a simple log to see your yields grow over time.
        </p>
      </div>

      <section>
        <div className="label-overline mb-3">Harvest calendar</div>
        <HarvestCalendar />
      </section>

      <section>
        <div className="label-overline mb-3">Yield analytics</div>
        <YieldChart />
      </section>
    </div>
  );
}
